<template>
  <div class="p-4">
    <div class="-content d-flex align-items-start flex-column">
      <div class="page-global-header px-0">
        <div v-if="limitExpireCheck">
          <div class="alert alert-danger" role="alert">
            Limit reached, Please subscribe.
          </div>
        </div>
        <div class="row justify-content-end mx-0">
          <div
            class="col-sm-12 col-md-12 col-lg-6 col-xl-5 col-xxl-5 d-flex justify-content-end"
          >
            <!-- <button class="btn btn-white">Expense No: 0123456789</button> -->
          </div>
        </div>
      </div>

      <div class="page-body" style="padding-top:1rem;">
        <div class="row mx-0">
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-5 col-xxl-5">
            <form class="base-form" style="padding-left: 80px;">
              <div class="row m-0 mb-3">
                <div class="input-group _group-xl p-0">
                  <span class="input-group-text bg-bostonBlue flush-after label-w-fixed">
                    Payment Method
                    <span class="required text-danger">*</span>
                  </span>
                  <select v-model="form.payment_type" required class="form-select">
                    <option disabled selected value="">Payment Method</option>
                    <option
                      v-for="option in payment_method"
                      :value="option"
                      :key="option"
                    >
                      {{ option }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row m-0 mb-3">
                <div class="input-group _group-xl p-0">
                  <span class="input-group-text bg-bostonBlue flush-after label-w-fixed">
                    Expense Date
                  </span>
                  <input
                    type="date"
                    name="datepick"
                    class="form-control datepicker text-end text-black _3d-input chevron-circle"
                    v-model="form.expense_date"
                    onfocus="this.showPicker()"
                    data-date-format="mm/dd/yyyy"
                  />
                </div>
              </div>

              <div class="row m-0 mb-3">
                <div class="input-group _group-xl p-0">
                  <span class="input-group-text bg-bostonBlue flush-after label-w-fixed">
                    Currency
                  </span>
                  <select
                    v-model="form.currency_id"
                    required
                    class="form-select"
                    @change="changeCurrency"
                  >
                    <option disabled selected value="">Currency*</option>
                    <option
                      v-for="option in currencyOptions"
                      :value="option.id"
                      :key="option.id"
                    >
                      {{ option.name }} ({{ option.symbol }})
                    </option>
                  </select>
                </div>
              </div>

              <div class="row m-0 mb-3 mt-5" style="width: 110%;">
                <div class="input-group _group-xl p-0">
                  <select v-model="form.category_id" required class="form-select">
                    <option disabled selected value="">Expense category*</option>
                    <option
                      v-for="option in expenseCategoryServer"
                      :value="option.id"
                      :key="option.id"
                    >
                      {{ option.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row m-0 mb-3" style="width: 110%;">
                <div class="input-group _group-xl p-0">
                  <input
                    type="text"
                    name="vendorName"
                    class="form-control"
                    placeholder="Name of the Vendor (Optional)"
                    v-model="form.vendor"
                  />
                </div>
              </div>

              <div class="row m-0 mb-4" style="width: 110%;">
                <div class="input-group _group-xl h-auto p-0">
                  <textarea
                    name="notes"
                    class="form-control textarea-lg no-resize"
                    placeholder="Notes..."
                    v-model="form.notes"
                  ></textarea>
                </div>
                <span class="form-text text-end text-stamp">Max 255 character</span>
              </div>

              <div class="row m-0 mb-3 mt-5 d-flex justify-content-end" style="width: 110%;">
                <div class="col-sm-12">
                  <div class="row">
                    <div class="input-group input-group--3d group-half p-0">
                      <div class="input-group-text bg-orange no-after">
                        Amount Paid
                        <span class="required text-danger"> *</span>
                      </div>
                      <div class="form-floating">
                        <label class="floating-label">{{ currency_symbol }}</label>
                        <input
                          class="form-control text-right"
                          type="text"
                          inputmode="decimal"
                          v-model="form.amount"
                          v-numeric
                          placeholder="10,000.00"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 mx-auto">
            <div class="preview-box" style="border: 2px solid #ccc; border-radius: 8px; background-color: #f8f9fa; min-height: 200px; display: flex; align-items: center; justify-content: center; overflow: hidden;">
              <el-carousel :interval="4000" v-if="image_list.length > 0" :key="image_list.length" arrow="always" style="width: 100%; height: 100%;">
                <el-carousel-item v-for="(image, index) in image_list" :key="index" style="position: relative;">
                  <img class="preview" :src="image.preview" />
                  <button
                    type="button"
                    class="btn btn-danger btn-sm position-absolute"
                    style="bottom: 15px; right: 15px; z-index: 10; border-radius: 50%; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 4px rgba(0,0,0,0.2);"
                    @click="removeImage(index)"
                  >
                    <i class="fa fa-trash-alt"></i>
                  </button>
                </el-carousel-item>
              </el-carousel>
              <span v-if="image_list.length === 0" class="text-muted">No image selected</span>
            </div>

            <div class="row mt-2">
              <div class="col-sm-12 d-flex align-items-center justify-content-center">
                <h6>Preview ({{ image_list.length }})</h6>
              </div>
            </div>

            <div class="row attachment-row">
              <div class="col-sm-12 d-flex align-items-center justify-content-center">
                <div class="custome-fileupload-circle">
                  <input
                    type="file"
                    class="file-input expense-file"
                    accept="image/jpeg, image/png"
                    @change="onFileChange"
                  />
                  <div class="file-content">
                    <div class="file-icon">
                      <i class="fa fa-camera"></i>
                    </div>
                    <div class="file-info-text">Add Attachment</div>
                  </div>
                </div>
              </div>
              <div
                class="col-sm-12 d-flex align-items-center justify-content-center mt-2"
              >
                <small>Note: Max 1 image, size: 512kb, png or jpeg only.</small>
              </div>
            </div>

            <div class="row action-buttons-row">
              <div class="col-sm-12 d-flex align-items-center justify-content-between" style="gap: 1rem;">
                <a href="/list-expenses" class="btn btn-default btn-shadow">Cancel</a>
                <button
                  v-if="!limitExpireCheck"
                  class="btn btn-success btn-shadow"
                  @click="saveData"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { CURRENCY_LIST } from "../../config/url";
import moment from "moment";

export default {
  name: "AddExpenseComponent",

  data() {
    const today = new Date();
    const formattedToday = today.toISOString().split("T")[0];
    return {
      loadingInstance: null,
      currency: null,
      payment_method: null,
      expense_category: null,
      form: {
        amount: "0.00",
        payment_type: "",
        expense_date: formattedToday,
        category_id: "",
        vendor: "",
        notes: "",
        currency_id: this.$store.state.auth.user.currency_id,
        image: [],
        is_image: "N",
      },
      image_list: [],
      image_count: 0,
      currency_symbol: this.$auth.user?.currency,
      getUserSubscriptionExpire: true,
      NoOFDaysFreeUsage: true,
      limitExpireCheck: false,
      getExpenseSubscriptionExpire: 0,
    };
  },
  mounted() {
    // Array to store promises from asynchronous functions
    const fetchPromises = [
      this.fetchCurrency(),
      this.fetchPaymentMethod(),
      this.expenseCategory(),
      this.getLimitForExpenses(),
    ];

    // Wait for all promises to resolve
    Promise.all(fetchPromises)
      .then(() => {
        this.getUserSubscriptionExpire = this.$store.getters[
          "auth/getUserSubscriptionExpire"
        ];
        this.NoOFDaysFreeUsage = this.$store.getters["auth/getUserNoOFDays"];

        if (
          this.getUserSubscriptionExpire &&
          this.NoOFDaysFreeUsage &&
          this.getExpenseSubscriptionExpire > 5
        ) {
          this.limitExpireCheck = true;
          this.$toast.error("Monthly limit reached.");
        }

        // Call changeCurrency() after all data is fetched
        this.changeCurrency();
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        // Handle errors if needed
      });
  },
  computed: {
    currencyOptions() {
      if (this.currency) {
        return this.currency.map((v) => {
          return {
            id: v.id,
            name: v.name,
            symbol: v.symbol,
          };
        });
      }
      return [];
    },
    expenseCategoryServer() {
      if (this.expense_category) {
        return this.expense_category.map((v) => {
          return {
            id: v.id,
            name: v.name,
          };
        });
      }
      return [];
    },
  },
  methods: {
    showLoading() {
      this.loadingInstance = this.$loading({
        lock: true,
        text: "Loading",
        background: "rgba(0, 0, 0, 0.7)",
        fullscreen: true,
      });
    },
    hideLoading() {
      this.loadingInstance.close();
    },
    saveData() {
      if (this.limitExpireCheck) {
        this.$toast.error("Monthly limit reached.");
        return false;
      }

      if (this.form.payment_type == "") {
        this.$toast.error("Payment method is required.");
        return;
      }

      if (this.form.category_id == "") {
        this.$toast.error("Expense category is required.");
        return;
      }

      // The field is a text input now, so compare the parsed value instead of
      // matching the "0.00" default string.
      if (!(parseFloat(this.form.amount) > 0)) {
        this.$toast.error("Amount is required.");
        return;
      }

      this.showLoading();

      this.form.expense_date = moment(this.form.expense_date)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      this.form.image = [];
      let form_data = new FormData();
      this.image_list.forEach((image) => {
        form_data.append("image[]", image.file);
      });

      form_data.append("amount", this.form.amount);
      form_data.append("payment_type", this.form.payment_type);
      form_data.append("expense_date", this.form.expense_date);
      form_data.append("category_id", this.form.category_id);
      form_data.append("vendor", this.form.vendor);
      form_data.append("notes", this.form.notes);
      form_data.append("currency_id", this.form.currency_id);
      form_data.append("is_image", this.form.is_image);

      this.$store
        .dispatch("expenses/saveExpenses", form_data)
        .then((res) => {
          // console.log(res);
          if (res.status == 1) {
            this.$toast.success("Save data Successful.");
            this.$router.push({ name: "list-expenses" });
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    async fetchCurrency() {
      this.currency = await this.axios
        .get(CURRENCY_LIST)
        .then(function (res) {
          return res.data.response;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async expenseCategory() {
      this.showLoading();
      this.expense_category = await this.$store
        .dispatch("expenses/getAllExpenseCategory")
        .then((res) => {
          if (res.status == 1) {
            return res.response;
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$toast.error("Something went wrong. Please try againddd.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    async fetchPaymentMethod() {
      this.showLoading();
      this.payment_method = await this.$store
        .dispatch("expenses/getPaymentOptions")
        .then((res) => {
          // console.log(res);
          if (res.status == 1) {
            return res.response;
            // this.$router.push({ name: 'user-dashboard' });
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    async onFileChange(e) {
      const files = Array.from(e.target.files);
      
      const resizedFiles = await Promise.all(
        files.map((file) => this.resizeImage(file, 512 * 1024))
      );

      const previews = await Promise.all(
        resizedFiles.map((file) => {
          return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (ev) => resolve({ file, preview: ev.target.result });
            reader.readAsDataURL(file);
          });
        })
      );

      this.image_list = previews.slice(0, 1);

      if (this.image_list.length > 0) {
        this.image_count = this.image_list.length;
        this.form.is_image = "Y";
      }
    },
    removeImage(index) {
      this.image_list.splice(index, 1);
      this.image_count = this.image_list.length;
      if (this.image_list.length === 0) {
        this.form.is_image = "N";
      }
    },

    resizeImage(file, maxSize) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        const reader = new FileReader();

        reader.onload = (e) => {
          img.src = e.target.result;
        };

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          // scale image to max width/height while preserving aspect ratio
          let width = img.width;
          let height = img.height;
          const maxDimension = 1024; // optional: resize large images to 1024px max

          if (width > height && width > maxDimension) {
            height *= maxDimension / width;
            width = maxDimension;
          } else if (height > maxDimension) {
            width *= maxDimension / height;
            height = maxDimension;
          }

          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);

          // Try compressing image under maxSize by adjusting quality
          let quality = 0.9;

          const attemptCompression = () => {
            canvas.toBlob(
              (blob) => {
                if (blob.size > maxSize && quality > 0.1) {
                  quality -= 0.1;
                  attemptCompression(); // try again with lower quality
                } else {
                  const resizedFile = new File([blob], file.name, {
                    type: blob.type,
                    lastModified: Date.now(),
                  });
                  resolve(resizedFile);
                }
              },
              "image/jpeg", // force jpeg to allow compression
              quality
            );
          };

          attemptCompression();
        };

        img.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    changeCurrency() {
      this.currency_symbol = this.currency.find(
        (currency) => currency.id === this.form.currency_id
      ).symbol;
    },
    getLimitForExpenses() {
      this.$store
        .dispatch("expenses/getExpensesLimit")
        .then((res) => {
          // console.log(res);
          if (res.status == 1) {
            this.getExpenseSubscriptionExpire = res.response.expense_count;
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
  },
};
</script>

<style scoped>
.el-carousel {
  border: 2px solid #ccc;
  padding: 0;
  background-color: #f8f9fa;
  border-radius: 8px;
  overflow: hidden;
}

.el-carousel__item {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.preview {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.attachment-row {
  margin-top: 4rem;
}

.action-buttons-row {
  margin-top: 5.5rem;
}
</style>

